<template>
    <span>
        <span :class="disabledButtonClasses" v-if="disabled">
            <i class="fas fa-trash"></i>
        </span>
        <call-dialog-link
            :id="id"
            :route="route"
            :message="message"
            :css-class="buttonClasses"
            v-if="!disabled"
        >
            <i class="fas fa-trash"></i>
        </call-dialog-link>
    </span>
</template>
<script>
    import CallDialogLink from './CallDialogLink';
    export default {
        components: {
            'call-dialog-link': CallDialogLink
        },
        props: {
            id: {
                type: [Number, String],
                required: true
            },
            route: {
                type: String,
                required: true
            },
            cssClass: {
                type: String,
                required: false
            },
            disabledCssClass: {
                type: String,
                required: false
            },
            recordName: {
                type: String,
                required: false
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                commonButtonClasses: 'alert button'
            }
        },
        computed: {
            buttonClasses() {
                let styling = this.commonButtonClasses;
                if (this.cssClass) {
                    styling += ' ' + this.cssClass;
                }
                return styling;
            },
            disabledButtonClasses() {
                let styling = this.commonButtonClasses + ' disabled';
                if (this.disabledCssClass) {
                    styling += ' ' + this.disabledCssClass;
                }
                return styling;
            },
            message() {
                if (!this.recordName) {
                    return 'Are you sure you wish to remove this record?';
                }
                return 'Are you sure you wish to remove ' + this.recordName + '?';
            }
        },
        mounted() {
            window.EventHandler.listen('confirm-dialog-' + this.id + '-called', responseObject => {
                window.location.reload(true);
            });
        }
    }
</script>